module.exports = __webpack_public_path__ + "static/img-gotronic-4029642a3a65f7c9be1b9798e821ba12.jpg";